import { FormattedMessage } from 'react-intl';

import { ConfluenceOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';
import { FeatureExposed } from '@/utils/feature-exposed/use-feature-exposed';

import { CreateAWorkspaceText } from '../../../components/create-a-workspace-heading';
import { Headings } from '../../../components/headings';

export const NewUser = () => {
	const confluenceWorkspaceText = (
		<FormattedMessage
			id="BxpUiSignup.nameSite.subHeader.newWorkspaceSubHeader"
			defaultMessage="This is the URL for your team to access Confluence. Most people use their team or company name."
		/>
	);

	return (
		<FeatureExposed experimentKey="cfind-3467-signup-with-image-overlay" group="isTreatment">
			<ConfluenceOverlayTemplate size="sm">
				<Headings main={<CreateAWorkspaceText />} sub={confluenceWorkspaceText} />
				<SiteActivation useContactExpandCohortLogic={true} />
			</ConfluenceOverlayTemplate>
		</FeatureExposed>
	);
};
